import request from '@/utils/request'

export function queryWxConfig(url) {
  return request({
    method: 'post',
    url: `/cls/passport-personal/app/wechat/getWxJsConfig`,
    data: {
        url
    },
  })
}
// 微信上传图片
export function uploadFileWx(data) {
  return request({
    method: 'post',
    url: `/cls/passport-personal/app/common/uploadFileWx?fileTypeCode=${ data.fileTypeCode }&serverId=${ data.serverId }`,
  })
}